import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = ({ language }) => {
  const texts = {
    en: {
      company: 'Loovafit',
      tagline: 'Spiele-Abo für Salt und Sunrise.',
      quickLinks: 'Quick links',
      contact: 'Contact',
      address: 'Clickshakers B.V.',
      email: 'gomobee.ch@silverlines.info',
      phone: '+41 44 581 61 61',
      privacy: 'Privacy',
      terms: 'Terms',
      impressum: 'Impressum',
      contactLink: 'Contact',
      rights: 'All rights reserved.',
      serviceNote: 'Loovafit is a subscription service that gives you access to games. You can play and download all provided games for the duration of your subscription. Enter your number and reply with JA (for Salt and Sunrise). The subscription costs CHF 10 per week (2 SMS/week for Salt, 1 SMS/week for Sunrise). To end the subscription, send STOP YES to 804 or contact us: +41 44 581 61 61 or gomobee.ch@silverlines.info. Domain and all advertising rights: Clickshakers B.V.',
    },
    de: {
      company: 'Loovafit',
      tagline: 'Spiele-Abo für Salt und Sunrise.',
      quickLinks: 'Links',
      contact: 'Kontakt',
      address: 'Clickshakers B.V.',
      email: 'gomobee.ch@silverlines.info',
      phone: '+41 44 581 61 61',
      privacy: 'Datenschutz',
      terms: 'AGB',
      impressum: 'Impressum',
      contactLink: 'Kontakt',
      rights: 'Alle Rechte vorbehalten.',
      serviceNote: 'Loovafit ist ein Abo-Dienst mit Zugriff auf Spiele. Du kannst alle bereitgestellten Spiele für die Dauer des Abonnements spielen und herunterladen. Nummer eingeben und mit JA antworten (für Salt und Sunrise). Das Abo kostet CHF 10 pro Woche (2 SMS/Woche Salt, 1 SMS/Woche Sunrise). Abo beenden: STOP YES an 804 senden oder Hotline +41 44 581 61 61, E-Mail gomobee.ch@silverlines.info. Die Domain und alle Werberechte sind im Besitz von Clickshakers B.V.',
    },
  };

  const t = texts[language];

  return (
    <footer className="bg-slate-900 border-t border-slate-800">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-10 mb-10">
          <div>
            <h3 className="text-lg font-heading font-bold text-brand-400 mb-2">
              {t.company}
            </h3>
            <p className="text-slate-400 text-sm">{t.tagline}</p>
            <p className="text-slate-500 text-xs mt-4 leading-relaxed">
              {t.serviceNote}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-slate-300 mb-4">{t.quickLinks}</h4>
            <ul className="space-y-2">
              <li>
                <a href="#section-2" className="text-slate-400 hover:text-brand-400 text-sm">
                  {language === 'en' ? 'Features' : 'Funktionen'}
                </a>
              </li>
              <li>
                <a href="#section-3" className="text-slate-400 hover:text-brand-400 text-sm">
                  {language === 'en' ? 'How it works' : 'So funktioniert’s'}
                </a>
              </li>
              <li>
                <a href="#section-4" className="text-slate-400 hover:text-brand-400 text-sm">
                  {language === 'en' ? 'Benefits' : 'Vorteile'}
                </a>
              </li>
              <li>
                <a href="/privacy.html" className="text-slate-400 hover:text-brand-400 text-sm">
                  {t.privacy}
                </a>
              </li>
              <li>
                <a href="/terms.html" className="text-slate-400 hover:text-brand-400 text-sm">
                  {t.terms}
                </a>
              </li>
              <li>
                <a href="/impressum.html" className="text-slate-400 hover:text-brand-400 text-sm">
                  {t.impressum}
                </a>
              </li>
              <li>
                <a href="/contact.html" className="text-slate-400 hover:text-brand-400 text-sm">
                  {t.contactLink || t.contact}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-slate-300 mb-4">{t.contact}</h4>
            <div className="space-y-3 text-slate-400 text-sm">
              <div className="flex items-center gap-2">
                <Mail className="w-4 h-4 text-brand-500 flex-shrink-0" />
                <a href={`mailto:${t.email}`} className="hover:text-brand-400">
                  {t.email}
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-4 h-4 text-brand-500 flex-shrink-0" />
                <a href={`tel:${t.phone}`} className="hover:text-brand-400">
                  {t.phone}
                </a>
              </div>
              <div className="flex items-start gap-2">
                <MapPin className="w-4 h-4 text-brand-500 flex-shrink-0 mt-0.5" />
                <span>{t.address}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} {t.company}. {t.rights}
          </p>
          <div className="flex gap-6">
            <a href="/privacy.html" className="text-slate-500 hover:text-brand-400 text-sm">
              {t.privacy}
            </a>
            <a href="/terms.html" className="text-slate-500 hover:text-brand-400 text-sm">
              {t.terms}
            </a>
            <a href="/impressum.html" className="text-slate-500 hover:text-brand-400 text-sm">
              {t.impressum}
            </a>
            <a href="/contact.html" className="text-slate-500 hover:text-brand-400 text-sm">
              {t.contactLink || t.contact}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
